<template>
    <BjDrawerForm ref="BjDrawerForm" :form="form" label-position="top" :rules="rules" label-width="600px" width="600px" @handleConfirm="handleConfirm">
      <el-col :span="24">
        <el-form-item :label="$t('rateCalculator.table.CustomerName')" prop="customName">
          <BjInput v-model="form.customName" :placeholder="$t('inputText')" clearable />
        </el-form-item>
      </el-col>
      <el-col :span="24">
        <el-form-item :label="$t('rateCalculator.table.profitmargin')" prop="profitMargin">
          <BjInputMoney v-model="form.profitMargin" :max="90" :min="0" :placeholder="$t('inputText')" clearable />
        </el-form-item>
      </el-col>
      <el-col :span="24">
        <el-form-item :label="$t('rateCalculator.table.ShippingAddress')">
          <BjInput disabled v-model="form.fromAddress" :placeholder="$t('inputText')" clearable />
        </el-form-item>
      </el-col>
      <el-col :span="24">
        <el-form-item :label="$t('WarehouseManagement.form.byPostCode')" prop="isPostcode">
          <BjSelectLov v-model="form.isPostcode" :option-list="STATUS_YES_TRUE" :clearable="false"/>
        </el-form-item>
      </el-col>
      <el-col :span="24">
        <el-form-item :label="$t('rateCalculator.table.Fileupload')" prop="logistics">
          <!-- <a href="https://minio.wooper.com/test/0/1733205168370_171I5IGK.xls" download class="downtext">{{ $t('ExcelConfig.Download') }}</a> -->
          <span class="downtext" @click="downFile">{{ $t('ExcelConfig.Download') }}</span>
          <el-upload ref="uploadRef" accept=".csv,.xls,.xlsx" action="" :limit="1" :auto-upload="false" :on-change="handleChange">
            <el-button type="primary">{{ $t('billingPage.ClickImport') }}</el-button>
          </el-upload>
        </el-form-item>
      </el-col>
      <el-col :span="24">
        <el-form-item :label="$t('WarehouseManagement.form.chooseLogistics')" prop="postCodeList">
          <BjSelectLov v-model="form.postCodeList" :option-list="LogisticsSelectionData" multiple />
        </el-form-item>
      </el-col>
    </BjDrawerForm>
</template>
<script>
import { afterApi, logisticApi } from '@/api';
import { STATUS_YES_TRUE } from '@/utils/constants';
import papa from 'papaparse';

const getDefaultForm = () => {
  return {
    fileName: null,
    customName: null,
    profitMargin: "",
    fromAddress: "AU, Dandenong South VIC 3175",
    logistics: [],
    postCodeList: [],
    fromSuburb:"AU",
    fromState:"VIC",
    fromPostcode:"3175",
    fromCountry:"Dandenong South",
    isPostcode: false,
  };
};
export default {
  name: '',
  data() {
    return {
      isEdit: false,
      STATUS_YES_TRUE,
      LogisticsSelectionData: [],
      form: getDefaultForm(),
      rules: {
        customName: [{ required: true, message: this.$t('inputText'), trigger: 'change' }],
        profitMargin: [{ required: true, message: this.$t('inputText'), trigger: 'change' }],
        logistics: [{ required: true, message: this.$t('inputText'), trigger: 'change' }],
      }
    };
  },
  created() {
    this.getDataOfSearch();
  },
  methods: {
    downFile(){
      fetch('https://minio.wooper.com/test/10/1761720151422_95WBGT8R_1752122760680_15JLS00Y.xls')
      .then(response => response.arrayBuffer())
      .then(data => {
          const blob = new Blob([data], { type: 'application/vnd.ms-excel' });
          const link = document.createElement('a');
          const url = URL.createObjectURL(blob);
          link.href = url;
          link.download = this.$t('rateCalculator.tables.fileMode');
          document.body.appendChild(link);
          link.click();
          document.body.removeChild(link);
          URL.revokeObjectURL(url);
      })
      .catch(error => {
          console.error('下载文件时出错:', error);
      });
    },
    show() {
      this.$refs.BjDrawerForm.show();
      this.$refs.BjDrawerForm.setTitle(this.$t('ChannelManagement.new.title'));
    },
    isValidToTwo(str) {
      return !isNaN(str) && str > 0;
    },
    isItInteger(value,tolerance = 1e-10){
      const rounded= Math.round(value);
      return Math.abs(value -rounded)< tolerance;
    },
    beforeVerify(dataList) {
      return new Promise((resolve, reject) => {
        let bstop = true
        const requireArr = ['Suburb', 'State', 'Postcode', 'Country', 'Total Weight(kg)', 'Length(L)cm', 'Width(W)cm', 'Height(H)cm', 'Qty(Q)', 'Price from Customer']
        const requireAr2 = [ 'Postcode', 'Total Weight(kg)', 'Length(L)cm', 'Width(W)cm', 'Height(H)cm', 'Qty(Q)', 'Price from Customer']
        const numberArr = ['Length(L)cm', 'Width(W)cm', 'Height(H)cm', 'Qty(Q)']
        const stringArr = ['Postcode', ]
        const decimalArr = ['Total Weight(kg)', 'Price from Customer']
        const AllArr = new Set([...requireArr, ...numberArr, ...decimalArr, 'OrderNumber', 'DeliveryAddress', 'SKUs']);
        // 20250417迭代 5867任务 ==> 前端去掉国家限制，改由后端验证
        // const StateArr = ['NSW', 'VIC', 'QLD', 'SA', 'WA', 'TAS', 'ACT', 'NT'];
        dataList.forEach(item => {
          AllArr.forEach(aitem => {
            // 内容前后含有空格
            if (/^\s|\s$/.test(item[aitem])) {
              bstop = false;
              item.errorTip = aitem + ' ' + this.$t('ExcelConfig.tip4');
              return;
            }
            // 20250417迭代 5867任务 ==> 前端去掉国家限制，改由后端验证
            // if(!this.form.isPostcode){
            //   // 州 缩写格式判断
            //   if (aitem === 'State' && !StateArr.includes(item[aitem])) {
            //     bstop = false;
            //     item.errorTip = aitem + ' ' + this.$t('ExcelConfig.tip5');
            //     return;
            //   }
            // }
          });
          // 根据邮编自动补充区、州、国
          if(this.form.isPostcode){
            requireAr2.forEach(jitem => {
              if (!item[jitem]) {
                bstop = false;
                item.errorTip = jitem + this.$t('emptyWarningText');
                return;
              }
            });
          }else{
            requireArr.forEach(jitem => {
              if (!item[jitem]) {
                bstop = false;
                item.errorTip = jitem + this.$t('emptyWarningText');
                return;
              }
            });
          }
          numberArr.forEach(jitem => {
            // console.log(this.isItInteger(item[jitem]))
            if(!(this.isItInteger(item[jitem]) && item[jitem] > 0)){
              bstop = false;
              item.errorTip = `${jitem} ${this.$t('ExcelConfig.tip1')}`;
              return;
            }else{
              item[jitem] = Number(item[jitem]).toFixed(0)
            }
          })
          decimalArr.forEach(jitem =>{
            if(!this.isValidToTwo(item[jitem])){
              bstop = false;
              item.errorTip = `${jitem} ${this.$t('ExcelConfig.tip2')}`;
              return;
            }
          })
          stringArr.forEach(jitem => {
            // console.log(typeof item[jitem]);
            if(typeof item[jitem] === "number"){
              item[jitem] = item[jitem].toString();
            }
          })
        })
        if(!bstop) {
          this.$confirm(`${this.$t('ExcelConfig.excelEroorTip1')}<br>${this.$t('ExcelConfig.excelEroorTip2')}<br>${this.$t('ExcelConfig.excelEroorTip3')}`, this.$t('toast.hintText'), {
            dangerouslyUseHTMLString: true,
            confirmButtonText: this.$t('downloadText'),
            cancelButtonText: this.$t('toast.cancelText'),
            type: 'warning',
          }).then(() => {
            let csvData = [];
            dataList.forEach(item => {
              csvData.push({
                'OrderNumber': item['OrderNumber'],
                'DeliveryAddress': item['DeliveryAddress'],
                'Suburb': item['Suburb'],
                'State': item['State'],
                'Postcode': item['Postcode'],
                'Country': item['Country'],
                'SKUs': item['SKUs'],
                'Total Weight(kg)': item['Total Weight(kg)'],
                'Length(L)cm': item['Length(L)cm'],
                'Width(W)cm': item['Width(W)cm'],
                'Height(H)cm': item['Height(H)cm'],
                'Qty(Q)': item['Qty(Q)'],
                'Price from Customer': item['Price from Customer'],
                'error': item.errorTip
              })
            })
            const csv = papa.unparse(csvData);
            const data = new Blob([csv], { type: 'text/csv;charset=utf-8;' });
            const csvURL = window.URL.createObjectURL(data);
            const download = document.createElement('a');
            document.body.appendChild(download);
            download.href = csvURL;
            download.setAttribute('download', 'Freight Calculator');
            download.click();
            document.body.removeChild(download);
            this.$refs.uploadRef.clearFiles()
          })
        }else{
          resolve(dataList);
        }
      })
    },
    handleChange(e) {
      const file = e.raw;
      this.form.fileName = e.name;
      this.form.logistics = [];
      const reader = new FileReader();
      reader.readAsArrayBuffer(file);
        reader.onload = ()=> {
        const buffer = reader.result;
        const bytes = new Uint8Array(buffer);
        const length = bytes.byteLength;
        let binary = '';
        for (let i = 0; i < length; i++) {
          binary += String.fromCharCode(bytes[i]);
        }
        const XLSX = require('xlsx');
        const wb = XLSX.read(binary, {
          type: 'binary',
          cellDates: true
        });
        const excelData = XLSX.utils.sheet_to_json(wb.Sheets[wb.SheetNames[0]]);
        this.beforeVerify(excelData).then((dataList) => {
            dataList.forEach(item => {
              this.form.logistics.push({
                'orderNumber': item['OrderNumber'],
                'deliveryAddress': item['DeliveryAddress'],
                'toCountry': item['Suburb'],
                'toState': item['State'],
                'toPostcode': item['Postcode'],
                'toSuburb': item['Country'],
                'skus': item['SKUs'],
                'totalWeight': item['Total Weight(kg)'],
                'length': item['Length(L)cm'],
                'width': item['Width(W)cm'],
                'height': item['Height(H)cm'],
                'qty': item['Qty(Q)'],
                'volume': Number(item['Length(L)cm'] * item['Width(W)cm'] * item['Height(H)cm'] * item['Qty(Q)'] / 1000000).toFixed(6),
                'customPrice': item['Price from Customer'],
              })
            })
        })
      };
    },
    async getDataOfSearch() {
      logisticApi.getLogisticsBusiness({ ...this.queryParams, enableFlag: true, size: 999 }).then(res => {
        if(res.content.length){
          const array = res.content.map(item => {
            return {
              label: item.name,
              value: item.name
            };
          });
          const newArray = [...array, {"label": "DFLC", "value": "DFLC"}];
          this.LogisticsSelectionData = newArray
        }
      })
    },

    handleConfirm() {
      afterApi.detailsaveDetails(this.form).then(res => {
        if(!res.failed){
          setTimeout(() => {
            this.$refs.BjDrawerForm.hide();
            this.form = getDefaultForm()
            this.$emit('reFresh');
            this.$message.success(this.$t('toast.operationSuccessText'));
          }, 500);
        }
      });
    },
  },

}
</script>
<style lang="scss" scoped>
.downtext{
  position: absolute;
  left: 100px;
  top: -27px;
  color: #082dc3;
  text-decoration: underline;
  cursor: pointer;
}
</style>
